import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import DataAudience from "@/pages/DataAudience";
import Compliance from "@/pages/Compliance";
import Partners from "@/pages/Partners";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import LegalCentre from "@/pages/LegalCentre";
import PolicyRoute from "@/pages/PolicyRoute";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/data-and-audience" element={<DataAudience />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/legal" element={<LegalCentre />} />
          <Route path="/legal/:slug" element={<PolicyRoute />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <Toaster richColors position="top-right" />
    </BrowserRouter>
  );
}

export default App;
